import { toDayKey } from './day-key.js';

function sameBase(a, b) {
  if (!a || !b) return false;
  if (a.id && b.id) return a.id === b.id;
  return a.name === b.name;
}

/**
 * Returns the base where the traveller is staying on `date` (ISO day key).
 * On overlap days (transfer), prefers the base with the later dateStart.
 */
export function getCurrentBase(bases, date = new Date()) {
  if (!bases?.length) return null;
  const key = typeof date === 'string' ? date.slice(0, 10) : toDayKey(date);

  const active = bases.filter((b) => key >= b.dateStart && key <= b.dateEnd);
  if (!active.length) return null;

  return active.sort((a, b) => b.dateStart.localeCompare(a.dateStart))[0];
}

export function sortBasesChronologically(bases) {
  return [...(bases ?? [])].sort((a, b) => a.dateStart.localeCompare(b.dateStart));
}

/**
 * @returns {Array<{ status: 'past'|'current'|'future', ...base }>}
 */
export function classifyBasesForTimeline(bases, date = new Date()) {
  const todayKey = typeof date === 'string' ? date.slice(0, 10) : toDayKey(date);
  const current = getCurrentBase(bases, date);

  return sortBasesChronologically(bases).map((base) => {
    let status = 'future';
    if (current && sameBase(base, current)) {
      status = 'current';
    } else if (todayKey > base.dateEnd) {
      status = 'past';
    } else if (todayKey < base.dateStart) {
      status = 'future';
    } else {
      status = 'past';
    }
    return { ...base, status };
  });
}
